import React from 'react';
import PropTypes from 'prop-types';
import Link from './shared/Link';
import utils from '../../../common/utils';

/**
 * Group stroke component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const GroupStroke = props => {
  const { groupAngle, groupScaleX } = props;
  const { shadow } = props.params;
  const objects = props.params.objects;
  const strokeObject = objects[0];
  const fillObject = objects[1];
  const type = strokeObject.type;

  const localScale = props.params.scaleX / groupScaleX;

  // To keep consistent with fabric logic, we apply transparency of div to the color itself.
  // Combine alpha of rgba with global opacity. This help to render
  // in CSS the same transparency as in fabric.
  const fillColor = utils.parseRGBA(
    (fillObject ? fillObject.fill : strokeObject.fill) || 'transparent',
  );
  const finalFillColor = utils.getRGBAStringFromRGBAObject({
    ...fillColor,
    a: fillColor.a * props.groupOpacity,
  });
  const strokeColor = utils.parseRGBA(strokeObject.stroke || 'transparent');
  const finalStrokeColor = utils.getRGBAStringFromRGBAObject({
    ...strokeColor,
    a: strokeColor.a * props.groupOpacity,
  });

  // TODO: use shared/BlockWrapper
  const blockStyles = {
    ...props.style,
    textIndent: '-99999px',
    opacity: 1.0,
    overflow: 'hidden',
    mixBlendMode:
      props.params.globalCompositeOperation === 'source-over'
        ? 'normal'
        : props.params.globalCompositeOperation,
    // We also need to apply the scale of the object when it's contained into a group.
    border: `${strokeObject.strokeWidth *
      props.params.scaleX}px solid ${finalStrokeColor}`,
    borderRadius:
      type === 'rect'
        ? `${strokeObject.rx * props.params.scaleX +
            (strokeObject.strokeWidth * props.params.scaleX) / 2}px`
        : '50%',
    backgroundColor: 'transparent',
    filter: shadow
      ? utils.getDropShadowCSSFilterFromFabricShadow(
          shadow,
          groupAngle,
          localScale,
        )
      : 'none',
  };
  const blockFill = {
    position: 'relative',
    backgroundColor: finalFillColor,
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    transformOrigin: 'top left',
  };
  return (
    <Link hyperlink={props.hyperlink} style={blockStyles}>
      <div style={blockFill} />
    </Link>
  );
};
GroupStroke.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number.isRequired,
  groupScaleX: PropTypes.number.isRequired,
  hyperlink: PropTypes.string,
};
GroupStroke.defaultProps = {
  hyperlink: null,
};

export default GroupStroke;
